import React from "react";
import PropTypes from "prop-types";

import "./NotificationTitle.scss";

export const NotificationTitle = ({ title }) => (
  <div className="notification-title">{title}</div>
);

NotificationTitle.propTypes = {
  title: PropTypes.node,
};
